import React from "react";
import { Icon } from "./Icon";
import { currentLanguageLabel } from "../utils";
import type { KioskLanguage } from "../types";

interface LanguageButtonProps {
  languages: KioskLanguage[];
  languageCode: string;
  onOpen: () => void;
}

/** The header language control, used on the wizard, the lookup screen and the Done bar. */
export const LanguageButton: React.FC<LanguageButtonProps> = ({
  languages,
  languageCode,
  onOpen
}) => {
  if (languages.length <= 1) return null;

  return (
    <button className="help" type="button" onClick={onOpen} title="Switch language">
      <Icon name="translate" size={18} />{" "}
      <span className="notranslate" translate="no">
        {currentLanguageLabel(languageCode, languages)}
      </span>
    </button>
  );
};
